import { MapboxOptions } from "mapbox-gl";
import { mapThemes } from "./map-themes";

export const baseOptions = Object.freeze<MapboxOptions>({
    container: "map",
    style: mapThemes.filter(x => x.default)[0].value,
    center: [-101.624905, 39.869059],
    zoom: 3,
    bearingSnap: 0,
    // antialias: true,
    // hash: true // Updates the URL with map properties
});